import React from 'react';
import CIcon from '@coreui/icons-react';
import { CButton } from '@coreui/react';

interface ScrollToBottomButtonProps {
  containerRef: React.RefObject<any>;
}

const ScrollToBottomButton = (props: ScrollToBottomButtonProps) => {
  const {
    containerRef
  } = props;

  const clickHandler = () => {
    containerRef?.current?.scrollIntoView!({
      behavior: "smooth",
      block: "end"
    });
  };

  return (
    <div className="scroll-to-bottom-button-wrapper">
      <CButton onClick={clickHandler} color='info' className="bg-color-orange border-0 scroll-to-bottom-button" >
        <CIcon size="xl" name="cil-arrow-bottom" />
      </CButton>
    </div>
  );
};

export default ScrollToBottomButton;
